import React from 'react'

const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10 5.71429H5.71429V10H4.28571V5.71429H0V4.28571H4.28571V0H5.71429V4.28571H10V5.71429Z'
      fill='currentColor'
    />
  </svg>
)

export default PlusIcon
